





























































import Component from "vue-class-component";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class Login extends mixins(MobileMixin, ErrorMixin) {
    public password: string = "";
    public passConfirmation: string = "";
    public show: boolean = false;
    public show2: boolean = false;
    public openKeyboard = false;

    public mounted() {
        const localeFromUrl = this.$route.query.locale as string;
        if (localeFromUrl) {
            this.$i18n.locale = localeFromUrl;
            this.$store.dispatch("login/setLanguage", localeFromUrl);
        }
    }

    public changePass(evt: any) {
        if (this.password === this.passConfirmation) {
            const payload = {
                email: this.$route.query.email,
                resetPasswordKey: this.$route.query.resetPasswordKey,
                password: this.password
            };
            this.$store.dispatch("login/reinitPassConfirmation", payload).then(
            (response: any) => {
                // console.log(response);
                this.$router.push({ name: "login" }).then(() => {
                    this.setSuccess(this.$t("SuccessMod").toString());
                });
            },
            (error: any) => {
                if (error.status === 400) {
                    this.$router.push({ name: "login" }).then(() => {
                        this.setErrorFromTxt(this.$t("userNull").toString());
                    });
                } else if (error.status === 406) {
                    this.$router.push({ name: "login" }).then(() => {
                        this.setErrorFromTxt(this.$t("expiredToken").toString());
                    });
                } else {
                    this.setErrorFromTxt(this.$t("error").toString());
                }
            }
            );
        }
    }
}
